import { render, staticRenderFns } from "./SpecialContentAdd.vue?vue&type=template&id=037b4b22&scoped=true"
import script from "./SpecialContentAdd.vue?vue&type=script&lang=js"
export * from "./SpecialContentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b4b22",
  null
  
)

export default component.exports